import type { FaireProductEntity } from "../../entity_types/product";

export const p_w35cbnsv3h: FaireProductEntity = {
  token: "p_w35cbnsv3h",
  type: "product",
  name: "Women's Cable Knit Funnel Neck Double Zip Jacket",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/dd593d60c53ac2737eea782e78819d435031b9e25ee60454f2d2fe4904c594c2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8147fed8073da910f466cbaa1ee1fa998d1fd1980f8389d073391f4c9c3180e8.jpeg",
    "https://cdn.faire.com/fastly/9cace58dd18141baf07c650a9ff1e97d54481b3dff49cff8243404dd19e97c79.jpeg",
    "https://cdn.faire.com/fastly/7d0c1fbba78c0bb1ea0467f581aaaca151f9a20055c3a310bf1322908ad4d58b.png",
    "https://cdn.faire.com/fastly/425ba2f9e70fe06286d7e002eaa6b3202dfe33f95b8448ee08034e3b269ad86a.jpeg",
    "https://cdn.faire.com/fastly/3904ded1df44c58a3c8a57121eeabcf2ae86b6846f1be7fea531d617bff98657.jpeg",
    "https://cdn.faire.com/fastly/efe2bddb66d92f5a30d647582c4a835f787c0acac70f47ced0b9c71f1a3b90ad.jpeg",
    "https://cdn.faire.com/fastly/5ed99e8025a25be59ab6b5bce3dba33db276129a792d897b314159393aeed508.jpeg",
    "https://cdn.faire.com/fastly/a3eb2cf590124a03382bd4436e73a4fce31a2e528080352894a685b0c8812b5b.jpeg",
    "https://cdn.faire.com/fastly/fc91f902d53f727d9edb798760599962cadde3ad7f1e116881698acaa9fbc265.png",
    "https://cdn.faire.com/fastly/64892db0e9ab3b67b3569015613fb0e57840605174acc4ff64d8e676128a10fe.jpeg",
    "https://cdn.faire.com/fastly/e22c1d079cf0c57b477828f878c43d4d1de8783af6f111259be9f76538b5bace.jpeg",
    "https://cdn.faire.com/fastly/57d13400776747a4bb10cfae35cd845eba62a48b5dd60c9aa23f25cc037b3372.jpeg",
    "https://cdn.faire.com/fastly/a97170af4c0c85d86467813e828e1e15bc2be4c6027fd9133f7135112cf1cde4.jpeg",
    "https://cdn.faire.com/fastly/74178b3ad0495a3a574d1ae34f5cddddc165e835cec92d4d9f3523356bfbe4e7.png"
  ],
  priceDollars: 70,
  description: "From cozy days and chilly evenings, this layer brings the perfect balance of warmth, texture, and style.\n\nFabrication:\nCrafted from Softies' signature Cable Knit Marshmallow fabric, this cozy construction delivers cloud-like softness while maintaining a polished look you'll reach for season after season.\n\nFeatures:\n● Funnel neckline provides added warmth and coverage\n● Double-zip closure offers versatile styling options\n● Cable-knit texture creates a cozy yet elevated finish\n\nMaterials & Care:\n● 100% Polyester\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n\nBest For:\n● Layering on cool mornings and evenings\n● Running weekend errands in comfort\n● Cozy travel days and everyday wear\n",
  tags: [],
  msrpDollars: 140,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:04.315Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
